// extracted by mini-css-extract-plugin
export default {"SnackbarContainerRoot":"KsGE4EJwTTkTbB6_1ghJ"};